export const getPointRelativeToElement = (point, element) => {
  const rect = element.getBoundingClientRect();
  return {
    x: point.x - rect.left,
    y: point.y - rect.top,
  };
};

export const getDistanceBetweenPoints = (pointA, pointB) =>
  Math.sqrt(
    Math.pow(pointA.y - pointB.y, 2) + Math.pow(pointA.x - pointB.x, 2)
  );

export const getScaledDimensions = (bounds, ratio) => {
  const maxWidth = bounds.width;
  const maxHeight = bounds.height;
  const scale = Math.min(maxWidth / ratio.width, maxHeight / ratio.height);

  return {
    width: Math.round(ratio.width * scale),
    height: Math.round(ratio.height * scale),
  };
};
